import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import FlashMessage from "@smartweb/vue-flash-message";
import { installAnalytics } from "./analytics";
import scrollReveal from "./directives/scrollReveal";
// Keep the shared ripple CSS in the synchronous app chunk so lazy route
// components cannot extract it in conflicting orders.
import "vuetify/src/directives/ripple/VRipple.sass";
import "@/assets/sass/main.scss";

Vue.use(FlashMessage);
Vue.directive("scroll-reveal", scrollReveal);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");

installAnalytics();
